"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getShortenedLocale = void 0;
function getShortenedLocale(canonicalLocale, supportedLocales) {
    if (supportedLocales.indexOf(canonicalLocale) === -1) {
        throw new Error(`Unsupported locale passed. Received: ${canonicalLocale}`);
    }
    for (const locale of supportedLocales) {
        if (locale.split('-')[0] !== canonicalLocale.split('-')[0]) {
            continue;
        }
        if (locale === canonicalLocale) {
            return locale.split('-')[0];
        }
        else {
            return canonicalLocale;
        }
    }
    return canonicalLocale;
}
exports.getShortenedLocale = getShortenedLocale;
